import { useState } from "react";
import type { ImageWithShimmerProps } from "../../pages/Crm/components/HelpDesk/components/KnowledgeBase/FileManagement/types/fileManagement.types";

const SHIMMER_CLASS =
  "w-full h-full bg-gradient-to-r from-[var(--color-gray-75)] to-[var(--color-gray-100)] dark:from-[var(--color-gray-75-dk)] dark:to-[var(--color-gray-100-dk)] animate-pulse rounded-lg";

const ImageWithShimmer = ({
  src,
  alt,
  imgClassName,
  wrapperClassName,
}: ImageWithShimmerProps) => {
  const [isLoaded, setIsLoaded] = useState(false);

  const handleLoaded = () => setIsLoaded(true);

  return (
    <div
      className={`relative ${wrapperClassName} ${
        !isLoaded ? "min-h-[300px]" : ""
      }`}
    >
      {!isLoaded && (
        <div className="absolute inset-0">
          <div className={SHIMMER_CLASS} />
        </div>
      )}
      <img
        key={src}
        src={src}
        alt={alt}
        onLoad={handleLoaded}
        onError={handleLoaded}
        className={`${imgClassName} ${isLoaded ? "block" : "invisible"}`}
      />
    </div>
  );
};

export default ImageWithShimmer;
